import styled from '@emotion/styled';
import { Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AddWhiteIcon, SuccessIconNew } from '../../../assets/images';
import { MuiButton, MuiPopup, MuiStack } from '../../../components';
var MyImg = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "48px",
        marginRight: "5px",
        width: "48px"
    };
});
function SavedSuccessfullyPopup(props) {
    var openPopUp = props.openPopUp, setOpenPopUp = props.setOpenPopUp, onClosePopup = props.onClosePopup, headerTitle = props.headerTitle, documentName = props.documentName, documentNo = props.documentNo, partData = props.partData, createNewDocument = props.createNewDocument, pagingNavigation = props.pagingNavigation;
    var _a = useState(0), requestedQty = _a[0], setRequestedQty = _a[1];
    var _b = useState(0), issuedQty = _b[0], setIssuedQty = _b[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var navigate = useNavigate();
    useEffect(function () {
        initialData();
    }, [requestedQty, issuedQty]);
    var initialData = function () {
        var reqQty = 0;
        var issuedQty = 0;
        partData === null || partData === void 0 || partData.map(function (item) {
            reqQty = reqQty + (item === null || item === void 0 ? void 0 : item.RequestedQuantity);
            issuedQty = issuedQty + (item === null || item === void 0 ? void 0 : item.IssueQuantity) + (item === null || item === void 0 ? void 0 : item.IssuedQuantity);
        });
        setRequestedQty(reqQty);
        setIssuedQty(issuedQty);
    };
    var onClose = function () {
        setOpenPopUp(false);
        onClosePopup(false);
    };
    return /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiPopup, {
        id: 'saved-successful-popup',
        variant: "h1",
        openPopup: openPopUp,
        onClose: function () { return onClose(); },
        closeIcon: true,
        subTitleVariant: "h4",
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: true,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            width: lgMode ? '500px' : 'calc(90vw)',
            paddingTop: 0,
            paddingX: "16px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        sm: 12,
        md: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MyImg, {
        id: "success-icon",
        src: SuccessIconNew,
        alt: "settingIcon"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        id: "success-content",
        flexDirection: "column",
        marginTop: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "success-title",
        fontSize: 'xl',
        fontWeight: 'strong'
    }, headerTitle), /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "row",
        marginTop: 1,
        alignItems: 'center',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "success-document-name",
        fontSize: 'base',
        fontWeight: 'normal',
        color: "secondary.900"
    }, documentName), /*#__PURE__*/ React.createElement(Typography, {
        id: "success-document-n0",
        fontSize: 'base',
        fontWeight: 'medium'
    }, documentNo), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        color: "black",
        sx: {
            marginLeft: 0
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        bgcolor: "secondary.50",
        padding: 2,
        marginTop: 2,
        borderRadius: 3
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "success-detail-document-name",
        fontSize: 'base',
        fontWeight: 'medium'
    }, documentName), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            marginY: 2
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between",
        spacing: 1,
        marginY: 1,
        id: "success-detail-part-card"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "success-detail-part-title",
        fontSize: 'base',
        fontWeight: 'normal'
    }, "Requested Quantity :"), /*#__PURE__*/ React.createElement(Typography, {
        id: "success-detail-part-qty",
        fontSize: 'base',
        fontWeight: 'normal'
    }, requestedQty, " ")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between",
        spacing: 1,
        marginY: 1,
        id: "success-detail-issued-card"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "success-detail-issued-title",
        fontSize: 'base',
        fontWeight: 'normal'
    }, "Issued Quantity :"), /*#__PURE__*/ React.createElement(Typography, {
        id: "success-detail-issued-qty",
        fontSize: 'base',
        fontWeight: 'normal'
    }, issuedQty, " "))), /*#__PURE__*/ React.createElement(MuiStack, {
        id: "success-detail-button-stack",
        direction: {
            xs: "column",
            sm: 'row-reverse'
        },
        spacing: 1.5,
        marginTop: 4
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "success-new-button",
        variant: "contained",
        size: "large",
        color: "primary",
        style: {
            borderColor: "secondary.200",
            width: "100%"
        },
        name: t("New"),
        onClick: createNewDocument,
        startIcon: /*#__PURE__*/ React.createElement("img", {
            src: AddWhiteIcon,
            color: "#FFFFFF"
        })
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "go-to-homepage",
        variant: "outlined",
        size: "large",
        color: "primary",
        style: {
            borderColor: "secondary.200",
            width: "100%"
        },
        name: t("Go to homepage"),
        onClick: function () { return navigate(pagingNavigation); }
    })))));
}
export default SavedSuccessfullyPopup;
